import { BaseApiManager } from "../util/baseApiManager";

export class SupportApiManager extends BaseApiManager {
    constructor() {
        super('/support')
    }

    getPublicKeys = async () => {
        try {
            const response = await this.customAxios.get(`/keys`)

            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    getDistricts = async () => {
        try {
            const response = await this.customAxios.get(`/districts`)
            
            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    createDistrict = async (districtInfo) => {
        try {
            await this.customAxios.post(`/districts`, {...districtInfo})
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    getSchoolsForDistrict = async (districtCode) => {
        try {
            const response = await this.customAxios.get(`/districts/${districtCode}/schools`)
            
            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    addSchool = async (districtCode, school) => {
        try {
            await this.customAxios.post(`/districts/${districtCode}/schools`, {schoolName: school})
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }
}